import _ from 'underscore';

export const mediaTypeTitleHash = {
	tours: 'Виртуальный тур',
	gallery: 'Фото и\u00A0видео',
	infographic: 'Инфографика',
	broadcast: 'Трансляции',
	events: 'События',
	performances: 'Спектакли'
};

export const getMediaBlocks = (data, entity) =>
	_(data).reduce((memo, block, type) => {
		if (!_.isEmpty(block)) {
			let mediaBlock;

			switch (type) {
				case 'tours':
				case 'broadcast':
				case 'events':
					mediaBlock = {
						image: block[0].thumbnailFile,
						instituteName: entity.sysName,
						instituteId: entity._id,
						values: block
					};
					break;
				case 'performances':
					mediaBlock = {
						image: entity.thumbnailFile,
						values: block
					};
					break;
				case 'infographic':
					mediaBlock = {
						image: block,
						values: [block]
					};
					break;
				case 'gallery': {
					let mainPhoto =
						_(block).findWhere({ type: 'image' }) ||
						_(block).findWhere({ type: 'video' });

					if (mainPhoto.type === 'video') {
						if (mainPhoto.files.length) {
							const [file] = mainPhoto.files;

							mainPhoto = file;
						} else {
							mainPhoto = entity.thumbnailFile;
						}
					}

					mediaBlock = {
						image: mainPhoto,
						values: block
					};
					break;
				}
				default:
					break;
			}

			return memo.concat({
				...mediaBlock,
				type,
				title: mediaTypeTitleHash[type]
			});
		}

		return memo;
	}, []);
